import React, { useState, useEffect, useContext } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import RTImportData from "components/RTImportData/RTImportData";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import postPageVisit from "services/LogService";
import AdvancedSearchContext from "context/AdvancedSearchContext";

export default function ImportsDonnees() {
  const [redirState, setRedirState] = useState(false);

  const appContext = useContext(AdvancedSearchContext);
  const {
    setPage,
  } = appContext;

  useEffect(() => {
    setPage('import');
    postPageVisit('import');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/import",
      }}
    />
  );

  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"import"}
    >
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <RTImportData />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  );
}
